import React from 'react';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  TagCloud,
  Tag
} from './styles';

const ThemesSection = () => {
  return (
    <ProfileCard>
      <CardTitle>Temas Principales</CardTitle>
      <CardContent>
        <TagCloud>
          <Tag>Desarrollo Económico</Tag>
          <Tag>Libertad</Tag>
          <Tag>Emprendedurismo</Tag>
          <Tag>Seguridad</Tag>
          <Tag>Medio Ambiente</Tag>
          <Tag>Planificación Urbana</Tag>
          <Tag>Humedales</Tag>
          <Tag>Infraestructura Portuaria</Tag>
          <Tag>Oportunidades para Jóvenes</Tag>
        </TagCloud>
      </CardContent>
    </ProfileCard>
  );
};

export default ThemesSection;
